import FormInput from "@standard/components/FormInput/FormInput";
import { UtilsService } from "@standard/services";
import React, { useEffect } from "react";
const $ = window.$;

export default function JobInfo({ value }) {
  useEffect(() => {
    $(".collapse-link-customer").on("click", function (e) {
      e.preventDefault();
      var ibox = $(this).closest("div.ibox");
      var button = $(this).find("i");
      var content = ibox.children(".ibox-content");
      content.slideToggle(200);
      button.toggleClass("fa-chevron-up").toggleClass("fa-chevron-down");
      ibox.toggleClass("").toggleClass("border-bottom");
      setTimeout(function () {
        ibox.resize();
        ibox.find("[id^=map-]").resize();
      }, 50);
    });
  }, []);

  return (
    <div className="row">
      <div className="col-12">
        <div className="ibox border-bottom">
          <div className="ibox-title bg-primary text-white">
            <h5>
              <i className="fa fa-briefcase" aria-hidden="true"></i>{" "}
              {value.name}
            </h5>
            <div className="ibox-tools">
              <a className="collapse-link-customer">
                <i className="fa fa-chevron-down"></i>
              </a>
            </div>
          </div>
          <div className="ibox-content" style={{ display: "none" }}>
            <div className="feed-activity-list">
              <div className="feed-element">
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <strong>Project Code: </strong>
                    {value.projectCode}
                  </div>
                  <div className="col-12 col-lg-6">
                    <strong>Job Name: </strong>
                    {value.name}
                  </div>
                  <div className="col-12 col-lg-6">
                    <strong>Customer Name: </strong>
                    {value.customerName}
                  </div>
                  <div className="col-12 col-lg-6">
                    <strong>Machine: </strong>
                    {value.machine}
                  </div>
                  <div className="col-12 col-lg-6">
                    <strong>Work Date: </strong>
                    {value.workDateText}
                  </div>
                  <div className="col-12 col-lg-6">
                    <strong>Owner Name: </strong>
                    {value.userName}
                  </div>
                  <div className="col-12 col-lg-6">
                    <strong>Services:</strong>
                    {UtilsService.htmlParse(value.serviceUsers)}
                  </div>
                  <div className="col-12 col-lg-6">
                    <strong>Remark:</strong>
                    {value.remark}
                  </div>
                  <div className="col-12">
                    <strong>Attach File:</strong>
                    <FormInput
                      field={{ name: "assetPreview", type: "filePreview" }}
                      value={value.assetsPreview}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
